import { DEFAULT_SOURCE_COLOR } from '../palette/types'
import { oklchToHex } from '../palette/utils'
import type { StorybookRule } from './storybook-rules'

type FakeNetwork = 'off' | 'fast' | 'slow' | 'fail'
type Language = 'en' | 'ru'
type Theme = 'light' | 'dark'

export function defaultStorybookSettings() {
  return {
    fakeNetwork: {
      type: 'fast' as FakeNetwork,
      preciseControl: false,
      controlledEndpoints: [] as string[],
    },
    language: 'en' as Language,
    theme: 'light' as Theme,
    reversedTheme: false,
    minimal: true,
    sourceColor: oklchToHex(DEFAULT_SOURCE_COLOR),
    sidebarPinned: false,
    rules: [] as StorybookRule[],
  }
}

export type StorybookSettings = ReturnType<typeof defaultStorybookSettings>
type Network = StorybookSettings['fakeNetwork']

function getNetworkFromUrl(): Network {
  const defaults = defaultStorybookSettings().fakeNetwork
  if (typeof window === 'undefined') return defaults

  const params = new URLSearchParams(location.search)
  const networkType = params.get('network')
  const pc = params.get('pc')
  const endpoints = params.get('endpoints')

  const isValidNetwork = (v: string | null): v is FakeNetwork =>
    v === 'off' || v === 'fast' || v === 'slow' || v === 'fail'

  return {
    type: isValidNetwork(networkType) ? networkType : defaults.type,
    preciseControl: pc === '1',
    controlledEndpoints: endpoints ? endpoints.split(',').filter(Boolean) : [],
  }
}

export function getFakeNetworkStatus(url: string) {
  const currentNetwork = getNetworkFromUrl()
  const defaultNetwork = defaultStorybookSettings().fakeNetwork

  let network: Network // if url is precisely controlled use currentNetwork, otherwise use defaultNetwork
  if (currentNetwork.preciseControl) {
    const matches = currentNetwork.controlledEndpoints.find((endpoint) =>
      url?.includes(endpoint),
    ) // ANOMALY: During hmr url is undefined
    if (matches) network = currentNetwork
    else network = defaultNetwork
  } else network = currentNetwork

  return network.type
}
